import actions from '../../actionTypes';

export default (email) => {
  return {
    type: actions.FORGOT_PASSWORD,
    email
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/forgotPassword.js